var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /usr/src/app/~/lodash/_Symbol.js
// module id = 48
// module chunks = 35783957827783 156715226241819